<mat-icon svgIcon="heroicons_solid:check-circle" style="color: #15757d"
    *ngIf="params.data.status == logStatusEnum.SUCCESS"></mat-icon>
<mat-icon svgIcon="heroicons_outline:check-circle" style="color: #b19527;"
    *ngIf="params.data.status == logStatusEnum.IN_PROGRESS"></mat-icon>
<mat-icon svgIcon="heroicons_solid:minus-circle" style="color: #ffa800"
    *ngIf="params.data.status == logStatusEnum.WARNING"></mat-icon>
<mat-icon svgIcon="heroicons_solid:x-circle" style="color: red" *ngIf="params.data.status == logStatusEnum.ERROR"></mat-icon>